/**
 * Created by Pali on 20/08/19.
 */

angular.module("screensApp")

  .controller("VirtualsEvonaController", function ($scope, $rootScope, $sce, $timeout) {
    $scope.betStopHasBeenSet = false; // Priznak ze prisiel betStop
    $scope.virtualEvonaURLSet = false; // Priznak, ci bola nastavena video url (Medzi betstopom a zaciatkom zapasu prisiel neprazdny streamUrl)
    $scope.timeSec = 0;

    $rootScope.showVirtualsEvona = function (data) {
      if (["sk"].includes($rootScope.config.LanguageId)) {
        $scope.evonaLang = $rootScope.config.LanguageId;
      } else {
        $scope.evonaLang = "en";
      }
      clearTimeout($rootScope.nextMatchesTimeout);
      if (data.Event) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showVirtualsEvona() data: ' + data);
        $scope.parseDetailFromBottomScreen(data);
      } else if (data.Events) {
        var nextMatches = data.Events.filter(function (race) {
          return race.ActualGamePartID == "notstarted";
        });
        if ($scope.offerData && $scope.offerData[0].EventID === nextMatches[0].EventID) {
        } else if (!$scope.offerData || ($scope.offerData && (nextMatches[0].RegionID !== $scope.regionIDtoPlay || $scope.offerData[0].EventID !== nextMatches[0].EventID))) {
          if (nextMatches[0].RegionID !== $scope.regionIDtoPlay) {
            $rootScope.hideVirtualsEvona(true);
          } else if ($scope.virtualEvonaURLSet || $scope.betStopHasBeenSet) {
            $rootScope.nextMatchesTimeout = setTimeout(function () {
              // New data arrived, but race not finished
              $rootScope.showVirtualsEvona(data);
            }, 2000);
            return false;
          }

          $scope.regionIDtoPlay = nextMatches[0].RegionID;
          $scope.regionName = nextMatches[0].RegionName;
          $scope.LeagueCupID = nextMatches[0].LeagueCupID;

          $scope.offerData = nextMatches;
          $scope.liveFeedReferenceToPlay = $scope.offerData[0].LiveFeedReference;
          $scope.nextEventID = $scope.offerData[0].EventName.split(" ")[1];
          $rootScope.getTimeDiff().then(function (data) {
            if (typeof $rootScope.timeDiff == "undefined") $rootScope.timeDiff = 0;
            $scope.secondsToNextRace = $rootScope.getSecondsDiff(nextMatches[0].EventDate, moment().valueOf() - $rootScope.timeDiff) + 10;
            $scope.betStopHasBeenSet = false;
            $rootScope.startCountdown($scope.secondsToNextRace);
            $scope.initLoader($scope.secondsToNextRace);

            if ($scope.secondsToNextRace < $rootScope.settings.virtualsEvona.pageTimeout / 1000) {
              $scope.getEvonaDetail(nextMatches[0].EventID).success(function (dataDetail) {
                $scope.showEvonaDetail(dataDetail);
              });
            } else {
              $scope.getEvonaResults().success(function (dataResults) {
                $scope.showEvonaResults(dataResults);
                // CrossRoad
                if ($scope.secondsToNextRace) {
                  $scope.evonaOfferPageTimeout = $timeout(
                    function () {
                      $scope.getEvonaDetail(nextMatches[0].EventID).success(function (dataDetail) {
                        $scope.showEvonaDetail(dataDetail);
                      });
                    },
                    $scope.secondsToNextRace * 1000 - $rootScope.settings.virtualsEvona.pageTimeout
                  );
                }
              });
            }
          });
        }
      }
    };

    $scope.showEvonaDetail = function (dataDetail) {
      if (dataDetail && dataDetail.Event) {
        $scope.parseDetail(dataDetail);
        $scope.evonaPageShowPerform("offer");
        $rootScope.settings.virtualsEvona.show = true;
        return true;
      } else if ($scope.detailData.Event) {
        $scope.evonaPageShowPerform("offer");
        $rootScope.settings.virtualsEvona.show = true;
        return true;
      }
    };

    $scope.showEvonaResults = function (dataResults) {
      if (dataResults && dataResults.Events) {
        $scope.parseResults(dataResults);
        $scope.evonaPageShowPerform("results");
        $rootScope.settings.virtualsEvona.show = true;
        return true;
      } else if ($scope.resultsData) {
        $scope.evonaPageShowPerform("results");
        $rootScope.settings.virtualsEvona.show = true;
        return true;
      }
    };

    $scope.evonaPageShowPerform = function (page) {
      if (page) {
        $scope.bonus = $scope.offer = $scope.results = $scope.startingRace = $scope.video = false;
        switch (page) {
          case "offer":
            $scope.header = $scope.regionName + " " + $rootScope.translations.evona[$scope.evonaLang].offer.header;
            $scope.nextRace = $rootScope.translations.evona[$scope.evonaLang].offer.nextRace;
            $scope.showNextRace = true;
            break;
          case "bonus":
            $scope.header = $rootScope.translations.evona[$scope.evonaLang].bonus.header;
            $scope.showNextRace = false;
            break;
          case "results":
            $scope.header = $rootScope.translations.evona[$scope.evonaLang].results.header;
            $scope.nextRace = $rootScope.translations.evona[$scope.evonaLang].results.nextRace;
            $scope.showNextRace = true;
            break;
          case "startingRace":
            $scope.header = $scope.regionName;
            $scope.showNextRace = false;
            break;
        }
        $scope.racerLabel = $rootScope.translations.evonaRacers[$scope.evonaLang][$scope.LeagueCupID].racerLabel.toUpperCase();
        $scope[page] = true;
      }
    };

    $rootScope.processEvonaUrls = function (hubData) {
      if (hubData.streamUrl && hubData.raceId && $scope.liveFeedReferenceToPlay == hubData.raceId) {
        $scope.virtualsEvonaHub = hubData;
        $scope.virtualsEvonaURL = $sce.trustAsResourceUrl($scope.virtualsEvonaHub.streamUrl);
        $scope.virtualEvonaURLSet = true;
      }
    };

    $rootScope.processEvonaBetStop = function (hubData) {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: processEvonaBetStop() hubData: ' + hubData);
      var eventToPlay =
        $scope.offerData &&
        $scope.offerData.find(function (event) {
          return event.EventID == hubData.eventID;
        });
      if (eventToPlay && hubData.actualGamePartID && hubData.actualGamePartID == "notstarted") {
        $timeout.cancel($scope.countDownPromise);
        $timeout.cancel($scope.evonaOfferPageTimeout);
        $scope.betStopHasBeenSet = true;
        $rootScope.startCountdown($rootScope.settings.virtualsEvona.playVideoTimeout / 1000);
        $scope.evonaPageShowPerform("startingRace");
      }
    };

    $rootScope.showVirtualsEvonaVideo = function () {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showVirtualsEvonaVideo() virtualEvonaURLSet: ' + $scope.virtualEvonaURLSet);
      if ($scope.virtualEvonaURLSet) {
        $scope.evonaPageShowPerform("video");
        $timeout(function () {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showVirtualsEvonaVideo() { SHOW VIDEO ACCEPTED }');
          $scope.virtualEvonaVideoElement = $("video#virtualEvonaVideo")[0];
          $scope.virtualEvonaVideoElement.play();
          $scope.virtualEvonaVideoElement.onended = function () {
            if ($scope.liveFeedReferenceToPlay == $scope.virtualsEvonaHub.raceId) {
              // Ostala otvorena hra s rovnakym id, ako bolo prehrate video
              // Nastavi default stav pre video
              $scope.virtualEvonaVideoElement.pause();
              $scope.virtualsEvonaURL = $sce.trustAsResourceUrl("");
              $scope.virtualEvonaURLSet = false;
              $scope.betStopHasBeenSet = false;

              $scope
                .getEvonaResults()
                .success(function (dataResults) {
                  $scope.showEvonaResults(dataResults);
                  if ($scope.detailData && $scope.detailData.EventID === dataResults.Events[0].EventID) {
                    $scope.detailData = null;
                  }
                })
                .error(function (err) {
                  $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: showVirtualsEvonaVideo() err: ' + err);
                  $rootScope.hideVirtualsEvona(true);
                });
            }
          };
        }, 0);
      } else {
        $rootScope.hideVirtualsEvona(true);
      }
    };

    // Hide VirtualsContainer
    $rootScope.hideVirtualsEvona = function (removeDetailData) {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideVirtualsEvona() removeDetailData: ' + removeDetailData);
      $rootScope.settings.virtualsEvona.show = false;
      $scope.bonus = $scope.offer = $scope.results = $scope.startingRace = $scope.video = false;
      $scope.virtualEvonaURLSet = $scope.nextEventID = false;
      $scope.resultsData = $scope.offerData = null;
      $scope.liveFeedReferenceToPlay = $scope.timeSec = 0;
      $timeout.cancel($scope.countDownPromise);
      $timeout.cancel($scope.evonaOfferPageTimeout);
      clearInterval($scope.loaderPartialTimeout);
      if ($scope.loader) {
        $scope.loader.css({ animation: "none" });
      }
      if (removeDetailData) {
        $scope.detailData = null;
      }
      $scope.loaderStateIndex = 1;
      if ($scope.virtualEvonaVideoElement) {
        $scope.virtualEvonaVideoElement.pause();
        $scope.virtualEvonaVideoElement.src = "";
      }
      $scope.virtualsEvonaURL = $sce.trustAsResourceUrl("");
    };

    // Odstartovanie odpocitavania
    $rootScope.startCountdown = function (countdownNumber) {
      if (countdownNumber) $rootScope.countdownNumber = countdownNumber + 1;
      $rootScope.countdownDisplayed = true;
      $scope.countDownPromise = $timeout(function () {
        $rootScope.countdownNumber--;
        if ($rootScope.countdownNumber > 0) {
          $rootScope.startCountdown();
        } else {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: startCountdown() { countdown finished, start video }');
          if ($scope.betStopHasBeenSet) $rootScope.showVirtualsEvonaVideo();
        }
      }, 1000);
    };

    $scope.parseResults = function (resultsData) {
      $scope.resultsData = new Object({
        LastOrderedEvent: {
          EventName: resultsData.Events[0].EventName,
          Odds: [],
        },
        OtherEvents: [],
      });
      resultsData.Events[0].Score.split("=")[1].split(",")
        .forEach(function (competitor, c) {
          if (resultsData.LastEventOdds[c]) {
            resultsData.LastEventOdds[c].competitorImage = $scope.assignCompetitorImage(competitor, resultsData.Events[0].Provider, resultsData.Events[0].LeagueCupID);
            $scope.resultsData.LastOrderedEvent.Odds.push(resultsData.LastEventOdds[c]);
          }
        });
      resultsData.Events.forEach(function (event) {
        $scope.resultsData.OtherEvents.push({
          EventName: event.EventName,
          CompetitorImages: event.Score.split("=")[1].split(",")
            .map(function (competitor) {
              return $scope.assignCompetitorImage(competitor, event.Provider, event.LeagueCupID);
            })
        });
      });
    };

    $scope.parseDetail = function (data) {
      var mappedECT = new Object({
        lvgWin: { Odds: [] },
        lvgPlace: { Odds: [] },
        lvgShow: { Odds: [] },
      });
      var competitorsWinners = new Array();
      data.Odds.forEach(function (odd) {
        if ($rootScope.settings.virtualsEvona.vgEvonaOfferECT.includes(data.EventChanceTypes[odd.EventChanceTypeID].ChanceTypeID)) {
          odd.name = data.Labels["TP_" + odd.TipID].Name.split("#")[1];
          if (data.EventChanceTypes[odd.EventChanceTypeID].ChanceTypeID === "lvgWin") {
            competitorsWinners.push(odd.name);
          }
          mappedECT[data.EventChanceTypes[odd.EventChanceTypeID].ChanceTypeID].Odds.push(odd);
        }
      });
      $scope.detailData = data.Event;
      // $scope.detailData.competitors = [...new Set(competitorsWinners)];
      $scope.detailData.competitors = competitorsWinners;

      Object.keys(mappedECT).forEach(function (ectName) {
        $scope.detailData[ectName] = mappedECT[ectName];
        $scope.detailData[ectName].competitorOdd = new Object();
        $scope.detailData[ectName].Odds.forEach(function (oddCompetitor) {
          oddCompetitor.competitorImage = $scope.assignCompetitorImage(oddCompetitor.name, $scope.detailData.Provider, $scope.detailData.LeagueCupID);
          $scope.detailData[ectName].competitorOdd[oddCompetitor.name] = oddCompetitor;
        });
      });
    };

    $scope.parseDetailFromBottomScreen = function (data) {
      $scope.detailData = data.Event;
      $scope.detailData.competitors = data.competitorsWinners;
      data.EventChanceTypes.forEach(function (ect) {
        if ($rootScope.settings.virtualsEvona.vgEvonaOfferECT.includes(ect.ChanceTypeID)) {
          $scope.detailData[ect.ChanceTypeID] = ect;
          if ($scope.detailData[ect.ChanceTypeID].Rows[1] && $scope.detailData[ect.ChanceTypeID].Rows[1].Odds) {
            $scope.detailData[ect.ChanceTypeID].Rows[0].Odds = $scope.detailData[ect.ChanceTypeID].Rows[0].Odds.concat($scope.detailData[ect.ChanceTypeID].Rows[1].Odds);
          }
          $scope.detailData[ect.ChanceTypeID].competitorOdd = new Object();
          $scope.detailData[ect.ChanceTypeID].Rows[0].Odds.forEach(function (oddCompetitor) {
            var competitorName = oddCompetitor.name.split("#")[1];
            oddCompetitor.competitorImage = $scope.assignCompetitorImage(competitorName, $scope.detailData.Provider, $scope.detailData.LeagueCupID);
            $scope.detailData[ect.ChanceTypeID].competitorOdd[competitorName] = oddCompetitor;
          });
        }
      });
    };

    // Funkcia vytvara img element/y s obrazkom competitora/ obrazkami competitora pre BetX/Kiron Virtualne hry
    $scope.assignCompetitorImage = function (competitorNumber, provider, leagueCupID) {
      var compImages = "";
      if (competitorNumber.includes("#")) {
        // Vitaz, napr. #1
        competitorNumber = [competitorNumber.replace(/\#/g, "").toString()];
      } else if (competitorNumber.length > 2 && competitorNumber.includes("-")) {
        // Viaceri competitory napr. 1-2
        competitorNumber = competitorNumber.split("-");
      } else {
        // Ostatne, napr. 1
        competitorNumber = [competitorNumber.toString()];
      }
      competitorNumber.forEach(function (cNumber) {
        compImages += "virtuals/" + provider.toLowerCase() + "/" + leagueCupID + "/competitor-" + cNumber + ".png";
      });
      return compImages;
    };

    $scope.initLoader = function (timeSec) {
      $scope.progressIds = ["emptyEvona", "quarterEvona ", "halfEvona", "threeQuartesEvona", "fullEvona"];
      $scope.timeSec = timeSec;
      $scope.timeMs = timeSec * 1000;
      $scope.timeMsPartial = $scope.timeMs / 4;
      $scope.progressQuartal = $("#loaderEvona .circle-partial-bg-evona")[0];
      $scope.progressQuartal.id = "emptyEvona";
      $scope.progressMask = $("#loaderEvona .mask-evona");
      $scope.progressMask[0].style.zIndex = 10;
      $scope.loader = $("#loaderEvona .loader-evona");
      $scope.loader.css({ animation: "none" });
      $scope.loaderStateIndex = 1;
      if ($scope.loaderPartialTimeout) clearInterval($scope.loaderPartialTimeout);

      $timeout(function () {
        $scope.loader.css({ animation: "spinning " + $scope.timeSec + "s linear" });
      }, 10);

      $scope.changeLoaderId();
    };

    // change loader indicator partials 4 - parts
    $scope.changeLoaderId = function () {
      $scope.loaderPartialTimeout = setInterval(function () {
        $scope.progressQuartal.id = $scope.progressIds[$scope.loaderStateIndex];
        if ($scope.loaderStateIndex == 2) {
          $scope.progressMask[0].style.zIndex = 0;
        }
        if ($scope.loaderStateIndex == 4) {
          $scope.loader.css({ animation: "none" });
          clearInterval($scope.loaderPartialTimeout);
        }
        ++$scope.loaderStateIndex;
      }, $scope.timeMsPartial);
    };

    $rootScope.getJackpot = function () {
      return $rootScope.setOfferUrl("Jackpot/site/stg/provider/btx");
    };

    $scope.getEvonaResults = function () {
      return $rootScope.setOfferUrl("VirtualGameResultList/LeagueCup/" + $scope.LeagueCupID + "/Top/1/LanguageID/" + $scope.evonaLang);
    };

    $scope.getEvonaDetail = function (eventID) {
      return $rootScope.setOfferUrl("OfferEventDetail/Event/" + eventID + "/Zone/" + $rootScope.config.TimeZone + "/LanguageID/" + $scope.evonaLang);
    };
  });
